__turbopack_context__.v({
  "image": "not-found-visual-module-scss-module__CWJ-Iq__image",
  "picture": "not-found-visual-module-scss-module__CWJ-Iq__picture",
});
